import React from 'react';
import { useI18n } from '../../i18n/I18nContext';
import { BrandMark } from '../Sidebar/Sidebar';
import './AppSplash.css';

/**
 * Branded full-screen loader shown while the session is being restored or a
 * lazy route chunk is loading — replaces the bare "Loading…" text so the
 * first paint already looks like Darsly.
 */
function AppSplash({ message, fullscreen = true }) {
  const { t } = useI18n();
  return (
    <div className={`app-splash ${fullscreen ? 'is-fullscreen' : ''}`} role="status" aria-live="polite">
      <div className="app-splash-mark">
        <BrandMark size={56} />
        <span className="app-splash-ring" aria-hidden="true" />
      </div>
      <p className="app-splash-text">{message || t('common.loading')}</p>
    </div>
  );
}

export default AppSplash;
